export type ModuleFlowItem<TTopic, TAssessment> =
  | { kind: 'topic'; topicIndex: number; displayOrder: number; topic: TTopic }
  | { kind: 'assessment'; assessmentIndex: number; displayOrder: number; assessment: TAssessment };

export function stripLeadingSequence(title: string): string {
  const trimmed = (title || '').replace(/^\s*\d+\s*[.)\]:-]\s+/, '').trim();
  return trimmed || (title || '').trim();
}

export function moduleFlow<TTopic extends { displayOrder?: number }, TAssessment extends { displayOrder?: number }>(
  topics: TTopic[] | undefined,
  assessments: TAssessment[] | undefined,
): ModuleFlowItem<TTopic, TAssessment>[] {
  const topicList = topics || [];
  const assessmentList = assessments || [];
  const topicItems = topicList.map((topic, topicIndex) => ({
    kind: 'topic' as const,
    topicIndex,
    displayOrder: Number(topic.displayOrder) > 0 ? Number(topic.displayOrder) : topicIndex + 1,
    topic,
  }));
  const assessmentItems = assessmentList.map((assessment, assessmentIndex) => ({
    kind: 'assessment' as const,
    assessmentIndex,
    displayOrder: Number(assessment.displayOrder) > 0 ? Number(assessment.displayOrder) : assessmentIndex + 1,
    assessment,
  }));
  return [...topicItems, ...assessmentItems].sort((a, b) => (
    a.displayOrder - b.displayOrder || (a.kind === 'topic' ? -1 : 1)
  ));
}

export function nextFlowOrder<TTopic extends { displayOrder?: number }, TAssessment extends { displayOrder?: number }>(
  topics: TTopic[] | undefined,
  assessments: TAssessment[] | undefined,
): number {
  const flow = moduleFlow(topics, assessments);
  return (flow.length ? Math.max(...flow.map((item) => item.displayOrder)) : 0) + 1;
}
